<template>
  <ClientOnly>
    <MobileMobileHeader v-if="isMobile()" />
    <template v-else>
      <Header />
      <!-- 悬浮 header 不透明时的占位符 -->
      <div v-show="route.name !== 'index'" style="height: 80px"></div>
    </template>
  </ClientOnly>
  <slot />
  <!-- pc mobile 通用 -->
  <Footer />
  <BackTop />
</template>

<script setup lang="ts">
import Header from '@/views/layouts/default/header.vue'
import MobileMobileHeader from '@/views/layouts/default/mobileHeader.vue'
import Footer from '@/views/layouts/default/footer.vue'
import BackTop from '@/components/backTop.vue'
import { useRoute } from '#imports'
import { isMobile } from '@/utils/systemInfo'

const route = useRoute()
</script>
